<p-dialog
	[visible]="visible()"
	(visibleChange)="onVisibleChange($event)"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '560px' }"
	[header]="run() ? 'Duplicating project' : 'Duplicate project'"
	styleClass="duplicate-project-dialog"
>
	@if (!run()) {
		<p class="dup-intro">
			Creates an independent copy of <strong>{{ project()?.name }}</strong> — scenes, images,
			settings and its own copy of every media file. The original is not touched.
		</p>

		<div class="dup-field">
			<label for="dup-name">Name</label>
			<input
				id="dup-name"
				pInputText
				type="text"
				[ngModel]="name()"
				(ngModelChange)="onNameChange($event)"
				[class.dup-invalid]="nameError()"
				autocomplete="off"
			/>
			@if (nameError()) {
				<span class="dup-error">{{ nameError() }}</span>
			}
		</div>

		<div class="dup-field">
			<label for="dup-slug">Slug</label>
			<input
				id="dup-slug"
				pInputText
				type="text"
				[ngModel]="slug()"
				(ngModelChange)="onSlugChange($event)"
				[class.dup-invalid]="slugError()"
				autocomplete="off"
				spellcheck="false"
			/>
			@if (slugError()) {
				<span class="dup-error">{{ slugError() }}</span>
			} @else {
				<span class="dup-hint">Used in URLs and media paths. Can't be changed later.</span>
			}
		</div>

		<div class="dup-field">
			<label for="dup-aspect">Format</label>
			<p-select
				inputId="dup-aspect"
				[options]="aspectOptions"
				[ngModel]="aspect()"
				(ngModelChange)="onAspectChange($event)"
				optionLabel="label"
				optionValue="value"
				appendTo="body"
			/>
		</div>

		<div class="dup-size-row">
			<div class="dup-field">
				<label for="dup-width">Width</label>
				<p-inputnumber
					inputId="dup-width"
					[ngModel]="width()"
					(ngModelChange)="onWidthChange($event)"
					[min]="1"
					[useGrouping]="false"
				/>
			</div>
			<div class="dup-field">
				<label for="dup-height">Height</label>
				<p-inputnumber
					inputId="dup-height"
					[ngModel]="height()"
					(ngModelChange)="onHeightChange($event)"
					[min]="1"
					[useGrouping]="false"
				/>
			</div>
		</div>
		@if (sizeError()) {
			<span class="dup-error">{{ sizeError() }}</span>
		}

		@if (formatChanged()) {
			<div class="dup-warning">
				<i class="pi pi-exclamation-triangle"></i>
				<span>
					Changing the format sets the copy's dimensions only — content coordinates keep
					their current values and will need redoing for the new format, along with the
					new footage.
				</span>
			</div>
		}

		@if (startError()) {
			<div class="dup-start-error">{{ startError() }}</div>
		}

		<ng-template #footer>
			<button type="button" pButton class="p-button-text" (click)="onClose()">Cancel</button>
			<button
				type="button"
				pButton
				class="p-button-primary"
				[disabled]="!canConfirm()"
				(click)="onConfirm()"
			>
				@if (starting()) {
					<i class="pi pi-spin pi-spinner"></i>
				}
				Duplicate
			</button>
		</ng-template>
	} @else {
		<div class="dup-progress">
			<div class="dup-progress-target">
				<i class="pi pi-copy"></i>
				<span>{{ run()?.targetName }}</span>
			</div>

			<div class="dup-bar" [class.dup-bar--error]="isError() || hasFailures()">
				<p-progressbar [value]="progressPercent()" [showValue]="false" />
			</div>

			<div class="dup-progress-label" [class.dup-progress-label--error]="isError()">
				{{ progressLabel() }}
			</div>

			@if (isRunning()) {
				<p class="dup-hint">
					This keeps running if you close the dialog — the copy already appears in the
					project list.
				</p>
			}

			@if (hasFailures()) {
				<div class="dup-warning">
					<i class="pi pi-exclamation-triangle"></i>
					<span>
						The copy is missing {{ failureCount() }} media file(s). Duplicate the project
						again, or delete this copy and retry.
					</span>
				</div>
			}
		</div>

		<ng-template #footer>
			@if (isRunning()) {
				<button type="button" pButton class="p-button-text" (click)="onClose()">Close</button>
			} @else {
				<button type="button" pButton class="p-button-text" (click)="onClose()">Done</button>
				@if (!isError()) {
					<button type="button" pButton class="p-button-primary" (click)="onOpenCopy()">
						Open copy
					</button>
				}
			}
		</ng-template>
	}
</p-dialog>
